stimulusApp.register(
  "help-request",
  class extends Stimulus.Controller {
    static formHiddenClass = "help-centre--submit-request_hidden"
    static formRevealClass = "help-centre--submit-request_visible"
    static formSwapClass = "help-centre--submit-request_swapping"
    static formSuccessClass = "help-centre--submit-request_success"
    static feedbackAnsweredClass = "help-centre--answer-feedback_answered"
    static feedbackHiddenClass = "help-centre--answer-feedback_hidden"
    static swapDurationMs = 180
    static targets = ["submitRequest", "answerFeedback"]

    #successfulSubmissions = new WeakSet()
    #url

    initialize() {
      this.#url = location.href
    }

    restore() {
      if (location.href === this.#url) return

      location.reload()
    }

    rate({ currentTarget, params: { properties } }) {
      const feedback = currentTarget.closest(".help-centre--answer-feedback")
      if (feedback.dataset.helpRequestRated) return

      feedback.dataset.helpRequestRated = "true"
      Activity.capture("help centre answer rated", properties)
    }

    answerHelped() {
      if (!this.hasAnswerFeedbackTarget) return

      this.answerFeedbackTarget.classList.add(
        this.constructor.feedbackAnsweredClass,
      )
      this.#hideSubmitRequest()
    }

    revealSubmitRequest(event) {
      const form = this.#formFor(event)
      if (!form) return
      if (this.#shouldBlockReveal(event)) return
      if (form.classList.contains(this.constructor.formRevealClass)) return

      form.classList.remove(this.constructor.formHiddenClass)
      form.classList.add(this.constructor.formRevealClass)
      if (!this.#fromNeedHelp(event)) this.#hideAnswerFeedback()
    }

    #formFor(event) {
      const origin = event?.currentTarget
      if (!origin) {
        return this.hasSubmitRequestTarget ? this.submitRequestTarget : null
      }

      const scope = origin.closest(
        ".help-centre--need-help, .collapsible-list--i--body, .help-centre--submit-request, .help-centre--ask",
      )
      if (scope) {
        if (scope.matches("[data-help-request-target='submitRequest']")) {
          return scope
        }

        const scoped = scope.querySelector(
          "[data-help-request-target='submitRequest']",
        )
        if (scoped) return scoped
      }

      return this.hasSubmitRequestTarget ? this.submitRequestTarget : null
    }

    #fromNeedHelp(event) {
      return Boolean(event?.currentTarget?.closest(".help-centre--need-help"))
    }

    #shouldBlockReveal(event) {
      return !this.#fromNeedHelp(event) && this.#answerMarkedHelpful()
    }

    #hideAnswerFeedback() {
      if (!this.hasAnswerFeedbackTarget) return

      this.answerFeedbackTarget.classList.add(
        this.constructor.feedbackHiddenClass,
      )
    }

    #answerMarkedHelpful() {
      return (
        this.hasAnswerFeedbackTarget &&
        this.answerFeedbackTarget.classList.contains(
          this.constructor.feedbackAnsweredClass,
        )
      )
    }

    cancel(event) {
      this.#hideSubmitRequest(this.#formFor(event))
      this.#showAnswerFeedback()
    }

    #hideSubmitRequest(form) {
      const forms = form ? [form] : this.submitRequestTargets

      forms.forEach((wrapper) => {
        if (wrapper.classList.contains(this.constructor.formSuccessClass))
          return

        wrapper.classList.remove(this.constructor.formRevealClass)
        wrapper.classList.add(this.constructor.formHiddenClass)
      })
    }

    #showAnswerFeedback() {
      if (!this.hasAnswerFeedbackTarget) return

      this.answerFeedbackTarget.classList.remove(
        this.constructor.feedbackHiddenClass,
      )
    }

    submitStart(event) {
      const submitButton =
        event.currentTarget.querySelector(".help-centre--btn")
      if (!submitButton) return

      submitButton.classList.add("btn_loading")
      submitButton.disabled = true
      this.#setCancelDisabled(event.currentTarget, true)
    }

    submitComplete(event) {
      if (this.#successfulSubmissions.has(event.currentTarget)) return

      const submitButton =
        event.currentTarget.querySelector(".help-centre--btn")
      if (!submitButton) return

      submitButton.classList.remove("btn_loading")
      submitButton.disabled = false
      this.#setCancelDisabled(event.currentTarget, false)
    }

    #setCancelDisabled(form, disabled) {
      const cancelButton = form.querySelector(".help-centre--cancel")
      if (!cancelButton) return

      cancelButton.disabled = disabled
    }

    submitSuccess(event) {
      const wrapper = event.currentTarget.closest(
        ".help-centre--submit-request",
      )
      if (!wrapper) return
      const successHtml = event.currentTarget.dataset.success

      this.#successfulSubmissions.add(event.currentTarget)
      wrapper.classList.add(this.constructor.formSwapClass)

      window.setTimeout(() => {
        wrapper.innerHTML = `<div class="help-centre--success" role="status">${successHtml}</div>`
        wrapper.classList.add(this.constructor.formSuccessClass)
        wrapper.classList.remove(this.constructor.formSwapClass)
      }, this.constructor.swapDurationMs)
    }
  },
)
